import { useCallback } from 'react'

import { useSegment } from '../../../hooks'

interface TrackProductAccountChangeParams {
  previousAccountId?: string
  nextAccountId?: string
}

export const useTrackProductAccount = () => {
  const { track } = useSegment()

  const trackProductAccountChange = useCallback(
    ({ previousAccountId, nextAccountId }: TrackProductAccountChangeParams) => {
      const hadAccount = !!previousAccountId
      const hasAccount = !!nextAccountId

      if (!hadAccount && hasAccount) {
        track('xxx - commerce - product account set', { hasAccount: true })
      } else if (hadAccount && hasAccount && previousAccountId !== nextAccountId) {
        track('xxx - commerce - product account updated', { hasAccount: true })
      } else if (hadAccount && !hasAccount) {
        track('xxx - commerce - product account removed', { hasAccount: false })
      }
    },
    [track],
  )

  return { trackProductAccountChange }
}
